module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a9-7-e8ba6e0de63ac046aa260d424631e4e5.jpg";